import axios from "axios"

export default{
    async GetLast10(){
        const response = await axios.get('/api/notification/get/last10notifications')
        return response
    },
    async SetStatusRead(id){
        const response = await axios.post(`/api/notification/setreadstatus/${id}`)
        return response
    },

}